import {
  Accessibility,
  AccessTime,
  AccessTimeOutlined,
  AccountBalanceOutlined,
  AccountCircle,
  Add,
  AddBox,
  AdjustOutlined,
  Alarm,
  Announcement,
  Apps,
  Archive,
  ArrowBack,
  ArrowDownward,
  ArrowDropDown,
  ArrowDropUp,
  ArrowForward,
  ArrowLeft,
  ArrowRight,
  ArrowUpward,
  ArticleOutlined,
  Assessment,
  AssessmentOutlined,
  Assignment,
  AssignmentOutlined,
  AssignmentTurnedIn,
  AssignmentTurnedInOutlined,
  AttachFile,
  AutoAwesomeOutlined,
  BackspaceOutlined,
  BarChart,
  Block,
  BorderAll,
  Brush,
  CalendarTodayOutlined,
  CancelOutlined,
  CancelScheduleSend,
  ChangeCircleOutlined,
  ChatBubbleOutline,
  Check,
  CheckBox,
  CheckCircle,
  CheckCircleOutlined,
  Circle,
  CircleOutlined,
  Close,
  CloseOutlined,
  Computer,
  ContentCopy,
  DateRangeOutlined,
  Delete,
  DeleteOutlined,
  Description,
  DesktopMac,
  DnsOutlined,
  DoDisturbAlt,
  Edit,
  EnhancedEncryption,
  ErrorOutline,
  EventAvailable,
  EventBusy,
  ExpandLess,
  ExploreOutlined,
  Feedback,
  FileDownload,
  FilterList,
  Flag,
  FlagOutlined,
  FolderZip,
  FormatColorFill,
  FormatListBulleted,
  Fullscreen,
  FullscreenExit,
  Group,
  HelpOutline,
  HelpOutlineOutlined,
  HighlightOff,
  HistoryOutlined,
  Home,
  ImportExport,
  InfoOutlined,
  KeyboardArrowDown,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  KeyboardArrowUp,
  LensBlur,
  LibraryBooks,
  LibraryBooksOutlined,
  LineWeight,
  ListAlt,
  LocalLibrary,
  Lock,
  LockOutlined,
  Loop,
  MenuOutlined,
  Message,
  MicNoneOutlined,
  ModeCommentOutlined,
  ModeEdit,
  MoreVert,
  NearMe,
  NoteOutlined,
  Numbers,
  OpenInNew,
  PanoramaOutlined,
  PauseCircleOutlined,
  People,
  Person,
  PlagiarismOutlined,
  PlayCircleOutlined,
  PlaylistRemove,
  Preview,
  PrintOutlined,
  Publish,
  QuestionAnswerOutlined,
  QuizOutlined,
  RadioButtonChecked,
  Redo,
  Remove,
  RemoveRedEye,
  ReplyOutlined,
  RestartAlt,
  RuleOutlined,
  SaveOutlined,
  ScheduleSend,
  Search,
  SearchOff,
  SellOutlined,
  Send,
  SendOutlined,
  SentimentDissatisfied,
  SettingsOutlined,
  SettingsSuggestOutlined,
  ShowChart,
  Shuffle,
  ShuffleOn,
  SignalCellularNodata,
  Sort,
  StarBorder,
  StopCircle,
  StopCircleOutlined,
  SwitchAccount,
  TextSnippet,
  ThumbUp,
  ThumbUpOutlined,
  Timelapse,
  Timer,
  Unarchive,
  Undo,
  VerifiedUser,
  VideocamOutlined,
  VisibilityOff,
  Warning,
  WarningAmber,
  ZoomIn,
  ZoomOut
} from "@mui/icons-material"

/**
 *
 * Gallery: https://material-ui.com/components/material-icons/
 *
 * API: https://material-ui.com/api/svg-icon/
 *
 */
export const MuiIcon = {
  AccessTime,
  AccessTimeOutlined,
  Accessibility,
  AccountBalanceOutlined,
  AccountCircle,
  Add,
  AddBox,
  AdjustOutlined,
  Alarm,
  Announcement,
  Apps,
  Archive,
  ArrowBack,
  ArrowDownward,
  ArrowDropDown,
  ArrowDropUp,
  ArrowForward,
  ArrowLeft,
  ArrowRight,
  ArrowUpward,
  Assessment,
  AssessmentOutlined,
  Assignment,
  AssignmentOutlined,
  AssignmentTurnedIn,
  AssignmentTurnedInOutlined,
  ArticleOutlined,
  AttachFile,
  BarChart,
  AutoAwesomeOutlined,
  BackspaceOutlined,
  Block,
  BorderAll,
  Brush,
  CalendarTodayOutlined,
  CancelOutlined,
  CancelScheduleSend,
  ChangeCircleOutlined,
  ChatBubbleOutline,
  Check,
  CheckBox,
  CheckCircle,
  CheckCircleOutlined,
  Circle,
  CircleOutlined,
  Close,
  CloseOutlined,
  Computer,
  ContentCopy,
  DateRangeOutlined,
  Delete,
  DeleteOutlined,
  Description,
  DesktopMac,
  DnsOutlined,
  DoDisturbAlt,
  Edit,
  EnhancedEncryption,
  ErrorOutline,
  EventAvailable,
  EventBusy,
  ExpandLess,
  ExploreOutlined,
  Feedback,
  FileDownload,
  FilterList,
  Flag,
  FlagOutlined,
  FolderZip,
  FormatColorFill,
  FormatListBulleted,
  Fullscreen,
  FullscreenExit,
  Group,
  ListAlt,
  HelpOutline,
  HelpOutlineOutlined,
  HighlightOff,
  HistoryOutlined,
  Home,
  ImportExport,
  InfoOutlined,
  KeyboardArrowDown,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  KeyboardArrowUp,
  LensBlur,
  LibraryBooks,
  LibraryBooksOutlined,
  LineWeight,
  Lock,
  LocalLibrary,
  LockOutlined,
  Loop,
  MenuOutlined,
  Message,
  MicNoneOutlined,
  ModeCommentOutlined,
  ModeEdit,
  MoreVert,
  NearMe,
  NoteOutlined,
  Numbers,
  OpenInNew,
  PanoramaOutlined,
  PauseCircleOutlined,
  People,
  Person,
  PlagiarismOutlined,
  PlayCircleOutlined,
  PlaylistRemove,
  Preview,
  PrintOutlined,
  Publish,
  QuestionAnswerOutlined,
  QuizOutlined,
  RadioButtonChecked,
  Redo,
  Remove,
  RemoveRedEye,
  ReplyOutlined,
  RestartAlt,
  RuleOutlined,
  SaveOutlined,
  ScheduleSend,
  Search,
  SearchOff,
  SellOutlined,
  Send,
  SendOutlined,
  SentimentDissatisfied,
  SettingsOutlined,
  SettingsSuggestOutlined,
  ShowChart,
  Shuffle,
  ShuffleOn,
  SignalCellularNodata,
  Sort,
  StarBorder,
  StopCircle,
  StopCircleOutlined,
  SwitchAccount,
  TextSnippet,
  Timelapse,
  Timer,
  ThumbUpOutlined,
  ThumbUp,
  Unarchive,
  Undo,
  VerifiedUser,
  VideocamOutlined,
  VisibilityOff,
  Warning,
  WarningAmber,
  ZoomIn,
  ZoomOut
}


